module.exports = __webpack_public_path__ + "b490e30c87bd21bd4b0ad7ed995f0152.MP3";